module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-jumbotron', {
    attrs: {
      "header": "slotlist.info",
      "lead": "ArmA 3 mission planning and slotlist management tool"
    }
  }, [_c('p', {
    staticClass: "text-justify"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" allows you to create and manage\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'missionList'
      }
    }
  }, [_vm._v("missions")]), _vm._v(", including slotlists for users to register for their desired roles.\n    "), _c('br'), _vm._v("The\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'communityList'
      }
    }
  }, [_vm._v("communities")]), _vm._v(" feature also allows you to represent your ArmA community on our website, further advertising your community's members and the missions created by them.\n    "), _c('br'), _vm._v("Since\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" uses Steam Single Sign-on, there's no need for your to create yet another account on a different website - all authentication is securely handled by Steam servers. You can get started right away by\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("logging in")]), _vm._v(" and\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'missionCreator'
      }
    }
  }, [_vm._v("creating a new mission")]), _vm._v("!\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Since\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("slotlist.info")]), _vm._v(" is still in development, there will be ongoing changes to the sites and the features (or data) provided by it. We will do our best to keep downtimes low and prevent any data loss, but please\n    "), _c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_vm._v("contact us")]), _vm._v(" regarding any suggestions or issues - should they arise.\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v("Thank you for using our service - I hope you enjoy it!\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-muted font-italic"
  }, [_vm._v("— MorpheusXAUT, slotlist.info developer")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54ea716d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/i18n/views/Home.en.vue
// module id = 525
// module chunks = 0